import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=a63ea7f0&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=a63ea7f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63ea7f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a63ea7f0')) {
      api.createRecord('a63ea7f0', component.options)
    } else {
      api.reload('a63ea7f0', component.options)
    }
    module.hot.accept("./ChatDialog.vue?vue&type=template&id=a63ea7f0&scoped=true", function () {
      api.rerender('a63ea7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatDialog/ChatDialog.vue"
export default component.exports